module.exports = __webpack_public_path__ + "img/start_game_on.1531d6bc.jpg";